import { useRef, useState } from 'react';
import { descargarClientesPdf } from '../services/clientesPdf';

export function useClientesPdf() {
  const [generando, setGenerando] = useState(false);
  const [error, setError] = useState('');
  const inFlight = useRef(false);
  const exportar = async clientes => {
    if (inFlight.current || !clientes.length) return;
    inFlight.current = true; setGenerando(true); setError('');
    try { await descargarClientesPdf(clientes.map(cliente => cliente.id)); }
    catch (e) {
      let data = e.response?.data;
      if (data instanceof Blob) {
        try { data = JSON.parse(await data.text()); } catch (_) { data = null; }
      }
      const message = data?.message;
      setError(Array.isArray(message) ? message.join('\n') : message || 'No se pudo generar el PDF.');
    } finally { inFlight.current = false; setGenerando(false); }
  };
  return { exportar, generando, error, cerrarError: () => setError('') };
}
